import {
  createQueryKeyStore,
  inferQueryKeyStore,
} from "@lukemorales/query-key-factory"
import { apiGatewayClient } from "./client"

export const ApiGatewayQueries = createQueryKeyStore({
  cancellationReason: {
    details: (accountNumber: string, meterpointId: number) => ({
      queryKey: [accountNumber, meterpointId],
      queryFn: () => Promise.resolve({ data: [] }),
      // TODO: Uncomment when endpoint is ready
      // apiClient.get(
      //   `/customers/cancellation-reason?accountNumber=${accountNumber}&meterPointId=${meterpointId}`
      // ),
    }),
  },
  paymentReviews: {
    list: (paymentReviewId: number, page: number, size: number) => ({
      queryKey: [paymentReviewId, page, size],
      queryFn: () =>
        apiGatewayClient.get(`payment-reviews/records`, {
          params: { paymentReviewId, page, size },
        }),
    }),
  },
  imbp: {
    availableSlots: (
      postcode: string,
      billingAccountId?: string,
      agentEmail?: string,
      mop?: string,
      mprn?: string,
      mpan?: string,
      meterType?: string,
    ) => ({
      queryKey: [
        postcode,
        billingAccountId,
        agentEmail,
        mop,
        mprn,
        mpan,
        meterType,
      ],
      queryFn: () => {
        const params = new URLSearchParams({
          postcode,
          ...(!!billingAccountId && {
            billing_account_id: billingAccountId,
            source: "nova",
          }),
          ...(!!agentEmail && { agent_email: agentEmail }),
          ...(!!mop && { mop }),
          ...(!!mprn && { mprn }),
          ...(!!mpan && { mpan }),
          ...(!!meterType && { meter_type: meterType }),
        })
        return apiGatewayClient.get(`smart-meter/available-slots?${params}`)
      },
    }),
    bookingInformation: (billingAccountId: number) => ({
      queryKey: [billingAccountId],
      queryFn: () =>
        apiGatewayClient.get(`smart-meter/${billingAccountId}/get-bookings`),
    }),
    cancellationReasons: () => ({
      queryKey: ["cancellationReasons"],
      queryFn: () =>
        apiGatewayClient.get("smart-meter/appt-cancel-reason-config"),
    }),
  },
  consent: {
    details: (meterpoints: string) => ({
      queryKey: [meterpoints],
      queryFn: () =>
        apiGatewayClient.get(
          `/smart-meter/meter-point/meter-reading-frequency?mpxns=${meterpoints}`,
        ),
    }),
  },
})

export type ApiGatewayQueryKeys = inferQueryKeyStore<typeof ApiGatewayQueries>
